import type { GameGuide } from '@songie/game-kit/client';

export const guide: GameGuide = {
  summary: 'Zar at, şehir al, yükselt. Rakibin senin otelinin kirasıyla batsın. Şans kartı çıkarsa istersen gerçek hayat görevi yap.',
  players: '2–12 oyuncu (tekli en fazla 8)',
  duration: '15–30 dk',
  sections: [
    {
      title: 'Amaç',
      body: 'Herkes 1.500 ₺ ile başlar. Tek başına ayakta kalan, üç renk grubunun tamamını toplayan ya da süre dolduğunda en zengin olan kazanır. Servet, para ile şehirlere yatırılan paranın toplamıdır.',
    },
    {
      title: 'Sıra sende',
      body: 'Zar at, piyonun yürür. Geldiğin kareye göre karar verirsin. Her kararın süresi var; süre dolunca otomatik geçilir.\n\nÇift atarsan bir daha atarsın. Üçüncü çift seni hapse gönderir. Başla\'dan her geçişte 200 ₺ alırsın.',
    },
    {
      title: 'Şehirler',
      items: [
        { term: 'Satın al', text: 'Sahipsiz şehri fiyatına alırsın, üstüne 1 ev gelir.', tone: 'green' },
        { term: 'Yükselt', text: 'Kendi şehrine her gelişte bir seviye yükseltebilirsin: 1, 2, 3 ev ve otel. Otelde kira fiyatın 4 katıdır.', tone: 'yellow' },
        { term: 'Renk grubu', text: 'Aynı renkteki iki şehir de sendeyse kira 2 kat olur. Üç grup toplayan oyunu anında kazanır.', tone: 'purple' },
        { term: 'Devral', text: 'Rakibin şehrinde kira ödedikten sonra, otel değilse şehri yatırılan paranın 2 katına alabilirsin.', tone: 'orange' },
      ],
    },
    {
      title: 'Şans kartı ve görev',
      body: 'Şans karesinde bir oyun kartı ve seçili paketlerden bir gerçek görev çıkar. Kartı uygula ya da görevi yap.\n\nGörevi seçersen süre işler. Bitirince rakipler "Yaptı" ya da "Yapamadı" der; eşitlikte görev başarılı sayılır. Başarırsan kötü kart iptal olur, iyi kartın parası 2 katına çıkar. Yapamaz ya da vazgeçersen kart uygulanır.',
      tip: 'İstemediğin bir görev mi çıktı? Kartı uygula yeter, kimse zorunda değil.',
    },
    {
      title: 'Diğer kareler',
      items: [
        { term: 'Vergi', text: 'Servetinin onda birini (en az 100 ₺) ödersin.', tone: 'neutral' },
        { term: 'Tur', text: '100 ₺ öde, istediğin kareye uç.', tone: 'neutral' },
        { term: 'Hapis', text: 'En fazla 2 tur kalırsın. Çift at ya da 150 ₺ kefalet öde.', tone: 'neutral' },
        { term: 'Mola', text: 'Soluklan, bir şey olmaz.', tone: 'neutral' },
      ],
    },
    {
      title: 'Borç ve iflas',
      body: 'Paran yetmezse şehir satarsın; yatırdığın paranın yarısını geri alırsın. Yine yetmezse iflas edersin, kalan paran alacaklıya, şehirlerin bankaya gider.',
    },
    {
      title: 'Ayarlar',
      items: [
        { term: 'Tekli ya da takımlı', text: 'Takımların tek piyonu, ortak parası ve şehirleri vardır; üyeler sırayla oynar. Takımlar eşit olmak zorunda değil.', tone: 'neutral' },
        { term: 'Oyun süresi', text: '15, 20 ya da 30 dakika. Son 5 dakikada bütün kiralar 2 kat olur.', tone: 'neutral' },
        { term: 'Gerçek hayat görevleri', text: 'Kapatırsan şans kartları yalnızca oyun içi uygulanır.', tone: 'neutral' },
        { term: 'Görev paketleri', text: 'Hareket, Taklit, Dans, Şarkı, Komik, Cesaret ve Arkadaş görevleri. Cesur ve Ateşli (+18) paketler yetişkinler içindir, varsayılan olarak kapalıdır.', tone: 'neutral' },
      ],
    },
  ],
};
